import React, { useState } from 'react';
import T from 'prop-types';
// redux, recompose
import { connect } from 'react-redux';
import { openPortal } from 'reducers/portal';
// components
import { SingleDatePicker as ReactDatesPicker } from 'react-dates';
import SingleDatePickerMobile from './SingleDatePickerMobile';
// utils
import cn from 'classnames';
import { isMobile } from 'react-device-detect';
import withOutsideClick from 'react-onclickoutside';
// regional date handling
import { getCurrentCountryCode } from 'selectors/regionalDateSelectors';
import { getInputPlaceholder, getMomentDisplayFormat } from 'utils/regionalDateHelper';
// styles
import 'react-dates/lib/css/_datepicker.css';
import './SingleDatePicker.scss';

const SingleDatePicker = (props) => {
  const [isFocused, setIsFocused] = useState(false);
  const {
    className = '',
    date,
    disabled,
    onDateChange,
    openPortal,
    isOutsideRange,
    withoutOutsideClickHandler,
    inputLabel,
    countryCode,
    placeholder,
    displayFormat,
    ...otherProps
  } = props;

  // Use regional formatting if not explicitly provided
  const effectiveInputLabel = inputLabel || getInputPlaceholder(countryCode);
  const effectiveDisplayFormat = displayFormat || getMomentDisplayFormat(countryCode);
  const effectivePlaceholder = placeholder || getInputPlaceholder(countryCode);

  const nestedProps = {
    disabled,
    isOutsideRange,
    placeholder: effectivePlaceholder,
    displayFormat: effectiveDisplayFormat,
  };

  const handleSetFocus = () => {
    if (!isFocused && !disabled) setIsFocused(true);
  };

  const handleChangeFocus = ({ focused }) => setIsFocused(focused);

  SingleDatePicker.handleClickOutside = () => {
    if (!withoutOutsideClickHandler) {
      setIsFocused(false);
    }
  };

  const handleOpenMobilePicker = (e) => {
    e.stopPropagation();
    if (disabled) return;
    openPortal(
      <SingleDatePickerMobile
        initialDate={date}
        onChange={onDateChange}
        isOutsideRange={isOutsideRange}
      />
    );
  };

  return (
    <div
      onClick={handleSetFocus}
      className={cn('SingleDatePickerWrapper', { [className]: !!className, focused: isFocused, isMobile })}
    >
      <ReactDatesPicker
        readOnly
        date={date}                         // momentPropTypes.momentObj or null,
        onDateChange={onDateChange}         // PropTypes.func.isRequired,
        onFocusChange={handleChangeFocus}
        focused={isFocused}
        numberOfMonths={1}
        hideKeyboardShortcutsPanel
        {...nestedProps}
      />
      <div className={cn('mobile-overlay', { 'active': isMobile })} onClick={handleOpenMobilePicker} />
      <div className="picker-label">{effectiveInputLabel}</div>
    </div>
  );
};

SingleDatePicker.propTypes = {
  className: T.string,
  date: T.object,
  onDateChange: T.func.isRequired,
  openPortal: T.func.isRequired,
  inputLabel: T.oneOfType([T.string, T.node]),
  isOutsideRange: T.func,
  withoutOutsideClickHandler: T.bool,
  countryCode: T.string,
  placeholder: T.string,
  displayFormat: T.string,
};

SingleDatePicker.defaultProps = {
  inputLabel: <i className="fa fa-calendar" />,
  countryCode: 'US',
};

const clickOutsideConfig = {
  handleClickOutside: () => SingleDatePicker.handleClickOutside
};

export default connect(
  (state) => ({
    countryCode: getCurrentCountryCode(state)
  }),
  { openPortal }
)(withOutsideClick(SingleDatePicker, clickOutsideConfig));
